import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Icon,
  Form,
  FormGroup,
  FormField,
  Radio,
  Dropdown,
  Checkbox,
  Divider,
  Button
} from 'semantic-ui-react'
import {
  DateTextBox
} from 'react-lib/apps/common'

const CardSelectAppointmentDatetimeUX = (props: any) => {
    return(
      <div
        id="ModEditDiscountUX-div-0"
        style={{padding: props.hideHeader?"0 0.5rem":"1rem"}}>
        <div
          id="ModSelectAppointmentDatetimeUX-div-1"
          style={{display:props.hideHeader?"none": "flex", justifyContent: "space-between"}}>

          <div
            id="ModSelectAppointmentDatetimeUX-div-2"
            style={{fontWeight: "bold"}}>
            {props.languageUX === "en" ? "Select Appointment Date & Time" : "เลือกวันที่และเวลานัดหมาย"}
          </div>
          <div
            id="ModSelectAppointmentDatetimeUX-div-3">

            <Icon
              color="red"
              id="ModSelectAppointmentDatetimeUX-Icon-4"
              link={true}
              name="close"
              onClick={props.onClose}>
            </Icon>
          </div>
        </div>
        <div
          className="ui divider"
          id="CardSelectAppointmentDatetimeUX-div-42"
          style={{display:props.hideHeader?"none": ""}}>

        </div>
        <Form
          className="size small --override-disabled --grey"
          id="ModSelectAppointmentDatetimeUX-Form-6">
          <FormGroup
            id="ModSelectAppointmentDatetimeUX-FormGroup-7"
            inline={true}
            style={{marginTop: "1.5rem", marginBottom: "-0.25rem"}}>
            <FormField
              id="ModSelectAppointmentDatetimeUX-FormField-8"
              inline={true}
              style={{display: props.hideCreateNew?"none":""}}>
              <Radio
                checked={props.filter?.type==="CREATE_NEW"}
                id="ModSelectAppointmentDatetimeUX-Radio-14"
                label={props.languageUX === "en" ? "Create new" : "สร้างใหม่"}
                name="type"
                onChange={props.onChangeFilter}
                style={{minWidth: "max-content"}}
                value="CREATE_NEW">
              </Radio>
            </FormField>
            <FormField
              id="ModSelectAppointmentDatetimeUX-FormField-9"
              inline={true}
              style={{position: "relative", paddingRight: 0}}
              width={3}>
              <div
                id="ModSelectAppointmentDatetimeUX-div-15"
                style={{width: "100%"}}>

                <DateTextBox
                  disabled={props.filter?.type==="COMBINE" && !props.hideHeader}
                  id="ModSelectAppointmentDatetimeUX-DateTextBox-16"
                  minDate={props.currentDate}
                  onChange={(value: any)=>props.onChangeFilter?.(null,{name:"date", value})}
                  value={props.filter?.date}>
                </DateTextBox>
              </div>
              <div
                id="ModSelectAppointmentDatetimeUX-div-21"
                style={{position: "absolute", top: "-1.25rem"}}>
                {props.languageUX === "en" ? "Select date" : "เลือกวันที่"}
              </div>
            </FormField>
            <FormField
              id="ModSelectAppointmentDatetimeUX-FormField-10"
              inline={true}
              style={{display: props.hideCombine?"none":""}}>
              <Radio
                checked={props.filter?.type==="COMBINE"}
                id="ModSelectAppointmentDatetimeUX-Radio-17"
                label={props.languageUX === "en" ? "Combine with" : "รวมกับ"}
                name="type"
                onChange={props.onChangeFilter}
                style={{minWidth: "max-content"}}
                value="COMBINE">
              </Radio>
            </FormField>
            <FormField
              id="ModSelectAppointmentDatetimeUX-FormField-11"
              inline={true}
              style={{display: props.hideCombine?"none":""}}
              width={4}>
              <Dropdown
                className="inline-label"
                clearable={true}
                fluid={true}
                id="ModSelectAppointmentDatetimeUX-Dropdown-18"
                loading={props.appointmentLoading}
                name="appointment"
                onChange={props.onChangeAppointment}
                options={props.appointmentOptions}
                placeholder="Select the desired appointment"
                search={true}
                selectOnBlur={false}
                selection={true}
                style={{width: "100%"}}
                value={props.filter?.appointment ?? ""}>
              </Dropdown>
            </FormField>
            <FormField
              className="inline-label"
              id="CardSelectAppointmentDatetimeUX-FormField-43"
              inline={true}
              style={{position: "relative", paddingRight: 0, display: props.showSelectDivision?"":"none"}}
              width={3}>
              <Dropdown
                fluid={true}
                id="CardSelectAppointmentDatetimeUX-Dropdown-46"
                name="division"
                onChange={props.onChangeFilter}
                options={props.divisionOptions}
                search={true}
                selection={true}
                style={{width: "100%"}}
                value={props.filter?.division ?? ""}>
              </Dropdown>
              <div
                id="CardSelectAppointmentDatetimeUX-div-45"
                style={{position: "absolute", top: "-1.25rem"}}>
                {props.languageUX === "en" ? "Select division" : "เลือกแผนก"}
              </div>
            </FormField>
            <FormField
              id="ModSelectAppointmentDatetimeUX-FormField-12"
              inline={true}
              style={{position: "relative", paddingRight: 0}}
              width={9}>
              <div
                id="ModSelectAppointmentDatetimeUX-div-40"
                style={{width: "100%"}}>
                {props.deviceDropdown}
              </div>
              <div
                id="ModSelectAppointmentDatetimeUX-div-22"
                style={{position: "absolute", top: "-1.25rem"}}>
                {props.languageUX === "en" ? "Select device" : "เลือกอุปกรณ์"}
              </div>
            </FormField>
            <FormField
              id="ModSelectAppointmentDatetimeUX-FormField-13"
              inline={true}>
              <Checkbox
                checked={props.filter?.isDeviceFree ?? false}
                disabled={!props.enabledDeviceFree}
                id="ModSelectAppointmentDatetimeUX-Checkbox-20"
                label="Device-free "
                name="isDeviceFree"
                onChange={props.onChangeFilter}
                style={{minWidth: "max-content"}}>
              </Checkbox>
            </FormField>
          </FormGroup>
        </Form>
        <Divider
          id="ModSelectAppointmentDatetimeUX-Divider-23">
        </Divider>
        <Form
          id="ModSelectAppointmentDatetimeUX-Form-24">
          <FormGroup
            id="ModSelectAppointmentDatetimeUX-FormGroup-25"
            inline={true}
            style={{marginTop: "-0.25rem"}}>
            <FormField
              id="ModSelectAppointmentDatetimeUX-FormField-26"
              inline={true}
              style={{display: "flex", alignItems: "center"}}>
              <div
                id="ModSelectAppointmentDatetimeUX-div-31"
                style={{width: "20px", height: "20px", backgroundColor: "rgba(186, 231, 241, 1)", borderRadius: "500rem"}}>

              </div>
              <div
                id="ModSelectAppointmentDatetimeUX-div-32">
                Available (Remaining/Total)
              </div>
            </FormField>
            <FormField
              id="ModSelectAppointmentDatetimeUX-FormField-27"
              inline={true}
              style={{display: "flex", alignItems: "center"}}>
              <div
                id="ModSelectAppointmentDatetimeUX-div-33"
                style={{width: "20px", height: "20px", backgroundColor: "rgba(33, 133, 208, 1)", borderRadius: "500rem"}}>

              </div>
              <div
                id="ModSelectAppointmentDatetimeUX-div-34">
                {props.languageUX === "en" ? "Patient’s booking" : "การจองของผู้ป่วย"}
              </div>
            </FormField>
            <FormField
              id="ModSelectAppointmentDatetimeUX-FormField-28"
              inline={true}
              style={{display: "flex", alignItems: "center"}}>
              <div
                id="ModSelectAppointmentDatetimeUX-div-35"
                style={{width: "20px", height: "20px", backgroundColor: "rgba(217, 217, 217, 1)", borderRadius: "500rem"}}>

              </div>
              <div
                id="ModSelectAppointmentDatetimeUX-div-36">
                {props.languageUX === "en" ? "Full / Not available" : "เต็ม / ไม่พร้อมใช้งาน"}
              </div>
            </FormField>
            <FormField
              id="ModSelectAppointmentDatetimeUX-FormField-29"
              style={{flex:1}}>
            </FormField>
            <FormField
              id="ModSelectAppointmentDatetimeUX-FormField-30"
              style={{paddingRight: 0, display: props.hideHeader?"none":""}}>
              <Button
                color="green"
                disabled={props.disabledMakeAppointment}
                id="ModSelectAppointmentDatetimeUX-Button-37"
                onClick={props.onMakeAppointment}
                size="small">
                <Icon
                  id="ModSelectAppointmentDatetimeUX-Icon-38"
                  name="calendar alternate outline">
                </Icon>
                <label
                  id="ModSelectAppointmentDatetimeUX-label-39"
                  style={{marginLeft: "6px"}}>
                  {props.languageUX === "en" ? "Make appointment" : "ทำการนัดหมาย"}
                </label>
              </Button>
            </FormField>
          </FormGroup>
        </Form>
        <div
          id="ModSelectAppointmentDatetimeUX-div-41">
          {props.table}
        </div>
        <div
          id="CardSelectAppointmentDatetimeUX-div-47"
          style={{ display: props.hideHeader&& props.filter?.devices?.length?"flex":"none", justifyContent: "flex-end", marginTop: "1rem"}}>

          <Button
            color="green"
            disabled={props.disabledMakeAppointment}
            id="CardSelectAppointmentDatetimeUX-Button-48"
            onClick={props.onMakeAppointment}
            size="small">

            <Icon
              id="CardSelectAppointmentDatetimeUX-Icon-49"
              name="calendar alternate outline">
            </Icon>
            <label
              id="CardSelectAppointmentDatetimeUX-label-50"
              style={{marginLeft: "6px"}}>
              {props.languageUX === "en" ? "Make appointment" : "ทำการนัดหมาย"}
            </label>
          </Button>
        </div>
      </div>
    )
}


export default CardSelectAppointmentDatetimeUX

export const screenPropsDefault = {"cannotPay":false,"cashAmountText":"14","citizenID":"31020000552","oweText":123,"patientNameAndHN":"HN: xxxxx นายทดสอบ","sumAmount":{"price":100,"reimbursable":42}}

/* Date Time : Fri Aug 22 2025 11:24:03 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "ModEditDiscountUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{padding: props.hideHeader?\"0 0.5rem\":\"1rem\"}"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ModSelectAppointmentDatetimeUX-div-1"
        },
        "style": {
          "type": "code",
          "value": "{display:props.hideHeader?\"none\": \"flex\", justifyContent: \"space-between\"}"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 2,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": "เลือกวันที่และเวลานัดหมาย",
          "valueEN": "Select Appointment Date & Time"
        },
        "id": {
          "type": "value",
          "value": "ModSelectAppointmentDatetimeUX-div-2"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\"}"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": null,
      "id": 3,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ModSelectAppointmentDatetimeUX-div-3"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 4,
      "name": "Icon",
      "parent": 3,
      "props": {
        "color": {
          "type": "value",
          "value": "red"
        },
        "id": {
          "type": "value",
          "value": "ModSelectAppointmentDatetimeUX-Icon-4"
        },
        "link": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "close"
        },
        "onClick": {
          "type": "code",
          "value": "props.onClose"
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 6,
      "name": "Form",
      "parent": 0,
      "props": {
        "className": {
          "type": "value",
          "value": "size small --override-disabled --grey"
        },
        "id": {
          "type": "value",
          "value": "ModSelectAppointmentDatetimeUX-Form-6"
        }
      },
      "seq": 23,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 7,
      "name": "FormGroup",
      "parent": 6,
      "props": {
        "id": {
          "type": "value",
          "value": "ModSelectAppointmentDatetimeUX-FormGroup-7"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{marginTop: \"1.5rem\", marginBottom: \"-0.25rem\"}"
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 8,
      "name": "FormField",
      "parent": 7,
      "props": {
        "id": {
          "type": "value",
          "value": "ModSelectAppointmentDatetimeUX-FormField-8"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: props.hideCreateNew?\"none\":\"\"}"
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 9,
      "name": "FormField",
      "parent": 7,
      "props": {
        "id": {
          "type": "value",
          "value": "ModSelectAppointmentDatetimeUX-FormField-9"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{position: \"relative\", paddingRight: 0}"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 9,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 10,
      "name": "FormField",
      "parent": 7,
      "props": {
        "id": {
          "type": "value",
          "value": "ModSelectAppointmentDatetimeUX-FormField-10"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: props.hideCombine?\"none\":\"\"}"
        }
      },
      "seq": 10,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 11,
      "name": "FormField",
      "parent": 7,
      "props": {
        "id": {
          "type": "value",
          "value": "ModSelectAppointmentDatetimeUX-FormField-11"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: props.hideCombine?\"none\":\"\"}"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 11,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 12,
      "name": "FormField",
      "parent": 7,
      "props": {
        "id": {
          "type": "value",
          "value": "ModSelectAppointmentDatetimeUX-FormField-12"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{position: \"relative\", paddingRight: 0}"
        },
        "width": {
          "type": "code",
          "value": "9"
        }
      },
      "seq": 13,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 13,
      "name": "FormField",
      "parent": 7,
      "props": {
        "id": {
          "type": "value",
          "value": "ModSelectAppointmentDatetimeUX-FormField-13"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 43,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 14,
      "name": "Radio",
      "parent": 8,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.filter?.type===\"CREATE_NEW\""
        },
        "id": {
          "type": "value",
          "value": "ModSelectAppointmentDatetimeUX-Radio-14"
        },
        "label": {
          "type": "value",
          "value": "สร้างใหม่",
          "valueEN": "Create new"
        },
        "name": {
          "type": "value",
          "value": "type"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeFilter"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        },
        "value": {
          "type": "value",
          "value": "CREATE_NEW"
        }
      },
      "seq": 14,
      "void": false
    },
    {
      "from": null,
      "id": 15,
      "name": "div",
      "parent": 9,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ModSelectAppointmentDatetimeUX-div-15"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 15,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 16,
      "name": "DateTextBox",
      "parent": 15,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.filter?.type===\"COMBINE\" && !props.hideHeader"
        },
        "id": {
          "type": "value",
          "value": "ModSelectAppointmentDatetimeUX-DateTextBox-16"
        },
        "minDate": {
          "type": "code",
          "value": "props.currentDate"
        },
        "onChange": {
          "type": "code",
          "value": "(value: any)=>props.onChangeFilter?.(null,{name:\"date\", value})"
        },
        "value": {
          "type": "code",
          "value": "props.filter?.date"
        }
      },
      "seq": 16,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 17,
      "name": "Radio",
      "parent": 10,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.filter?.type===\"COMBINE\""
        },
        "id": {
          "type": "value",
          "value": "ModSelectAppointmentDatetimeUX-Radio-17"
        },
        "label": {
          "type": "value",
          "value": "รวมกับ",
          "valueEN": "Combine with"
        },
        "name": {
          "type": "value",
          "value": "type"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeFilter"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        },
        "value": {
          "type": "value",
          "value": "COMBINE"
        }
      },
      "seq": 17,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 18,
      "name": "Dropdown",
      "parent": 11,
      "props": {
        "className": {
          "type": "value",
          "value": "inline-label"
        },
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "ModSelectAppointmentDatetimeUX-Dropdown-18"
        },
        "loading": {
          "type": "code",
          "value": "props.appointmentLoading"
        },
        "name": {
          "type": "value",
          "value": "appointment"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeAppointment"
        },
        "options": {
          "type": "code",
          "value": "props.appointmentOptions"
        },
        "placeholder": {
          "type": "value",
          "value": "Select the desired appointment"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selectOnBlur": {
          "type": "code",
          "value": "false"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.filter?.appointment ?? \"\""
        }
      },
      "seq": 18,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 20,
      "name": "Checkbox",
      "parent": 13,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.filter?.isDeviceFree ?? false"
        },
        "disabled": {
          "type": "code",
          "value": "!props.enabledDeviceFree"
        },
        "id": {
          "type": "value",
          "value": "ModSelectAppointmentDatetimeUX-Checkbox-20"
        },
        "label": {
          "type": "value",
          "value": "Device-free "
        },
        "name": {
          "type": "value",
          "value": "isDeviceFree"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeFilter"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 20,
      "void": false
    },
    {
      "from": null,
      "id": 21,
      "name": "div",
      "parent": 9,
      "props": {
        "children": {
          "type": "value",
          "value": "เลือกวันที่",
          "valueEN": "Select date"
        },
        "id": {
          "type": "value",
          "value": "ModSelectAppointmentDatetimeUX-div-21"
        },
        "style": {
          "type": "code",
          "value": "{position: \"absolute\", top: \"-1.25rem\"}"
        }
      },
      "seq": 21,
      "void": false
    },
    {
      "from": null,
      "id": 22,
      "name": "div",
      "parent": 12,
      "props": {
        "children": {
          "type": "value",
          "value": "เลือกอุปกรณ์",
          "valueEN": "Select device"
        },
        "id": {
          "type": "value",
          "value": "ModSelectAppointmentDatetimeUX-div-22"
        },
        "style": {
          "type": "code",
          "value": "{position: \"absolute\", top: \"-1.25rem\"}"
        }
      },
      "seq": 40,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 23,
      "name": "Divider",
      "parent": 0,
      "props": {
        "id": {
          "type": "value",
          "value": "ModSelectAppointmentDatetimeUX-Divider-23"
        }
      },
      "seq": 24,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 24,
      "name": "Form",
      "parent": 0,
      "props": {
        "id": {
          "type": "value",
          "value": "ModSelectAppointmentDatetimeUX-Form-24"
        }
      },
      "seq": 41,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 25,
      "name": "FormGroup",
      "parent": 24,
      "props": {
        "id": {
          "type": "value",
          "value": "ModSelectAppointmentDatetimeUX-FormGroup-25"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{marginTop: \"-0.25rem\"}"
        }
      },
      "seq": 25,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 26,
      "name": "FormField",
      "parent": 25,
      "props": {
        "id": {
          "type": "value",
          "value": "ModSelectAppointmentDatetimeUX-FormField-26"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\"}"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 26,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 27,
      "name": "FormField",
      "parent": 25,
      "props": {
        "id": {
          "type": "value",
          "value": "ModSelectAppointmentDatetimeUX-FormField-27"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\"}"
        }
      },
      "seq": 27,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 28,
      "name": "FormField",
      "parent": 25,
      "props": {
        "id": {
          "type": "value",
          "value": "ModSelectAppointmentDatetimeUX-FormField-28"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\"}"
        }
      },
      "seq": 28,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 29,
      "name": "FormField",
      "parent": 25,
      "props": {
        "id": {
          "type": "value",
          "value": "ModSelectAppointmentDatetimeUX-FormField-29"
        },
        "style": {
          "type": "code",
          "value": "{flex:1}"
        }
      },
      "seq": 29,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 30,
      "name": "FormField",
      "parent": 25,
      "props": {
        "id": {
          "type": "value",
          "value": "ModSelectAppointmentDatetimeUX-FormField-30"
        },
        "style": {
          "type": "code",
          "value": "{paddingRight: 0, display: props.hideHeader?\"none\":\"\"}"
        }
      },
      "seq": 30,
      "void": false
    },
    {
      "from": null,
      "id": 31,
      "name": "div",
      "parent": 26,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ModSelectAppointmentDatetimeUX-div-31"
        },
        "style": {
          "type": "code",
          "value": "{width: \"20px\", height: \"20px\", backgroundColor: \"rgba(186, 231, 241, 1)\", borderRadius: \"500rem\"}"
        }
      },
      "seq": 31,
      "void": false
    },
    {
      "from": null,
      "id": 32,
      "name": "div",
      "parent": 26,
      "props": {
        "children": {
          "type": "value",
          "value": "Available (Remaining/Total) "
        },
        "id": {
          "type": "value",
          "value": "ModSelectAppointmentDatetimeUX-div-32"
        }
      },
      "seq": 32,
      "void": false
    },
    {
      "from": null,
      "id": 33,
      "name": "div",
      "parent": 27,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ModSelectAppointmentDatetimeUX-div-33"
        },
        "style": {
          "type": "code",
          "value": "{width: \"20px\", height: \"20px\", backgroundColor: \"rgba(33, 133, 208, 1)\", borderRadius: \"500rem\"}"
        }
      },
      "seq": 33,
      "void": false
    },
    {
      "from": null,
      "id": 34,
      "name": "div",
      "parent": 27,
      "props": {
        "children": {
          "type": "value",
          "value": "การจองของผู้ป่วย",
          "valueEN": "Patient’s booking"
        },
        "id": {
          "type": "value",
          "value": "ModSelectAppointmentDatetimeUX-div-34"
        }
      },
      "seq": 34,
      "void": false
    },
    {
      "from": null,
      "id": 35,
      "name": "div",
      "parent": 28,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ModSelectAppointmentDatetimeUX-div-35"
        },
        "style": {
          "type": "code",
          "value": "{width: \"20px\", height: \"20px\", backgroundColor: \"rgba(217, 217, 217, 1)\", borderRadius: \"500rem\"}"
        }
      },
      "seq": 35,
      "void": false
    },
    {
      "from": null,
      "id": 36,
      "name": "div",
      "parent": 28,
      "props": {
        "children": {
          "type": "value",
          "value": "เต็ม / ไม่พร้อมใช้งาน",
          "valueEN": "Full / Not available"
        },
        "id": {
          "type": "value",
          "value": "ModSelectAppointmentDatetimeUX-div-36"
        }
      },
      "seq": 36,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 37,
      "name": "Button",
      "parent": 30,
      "props": {
        "color": {
          "type": "value",
          "value": "green"
        },
        "disabled": {
          "type": "code",
          "value": "props.disabledMakeAppointment"
        },
        "id": {
          "type": "value",
          "value": "ModSelectAppointmentDatetimeUX-Button-37"
        },
        "onClick": {
          "type": "code",
          "value": "props.onMakeAppointment"
        },
        "size": {
          "type": "value",
          "value": "small"
        }
      },
      "seq": 37,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 38,
      "name": "Icon",
      "parent": 37,
      "props": {
        "id": {
          "type": "value",
          "value": "ModSelectAppointmentDatetimeUX-Icon-38"
        },
        "name": {
          "type": "value",
          "value": "calendar alternate outline"
        }
      },
      "seq": 38,
      "void": false
    },
    {
      "from": null,
      "id": 39,
      "name": "label",
      "parent": 37,
      "props": {
        "children": {
          "type": "value",
          "value": "ทำการนัดหมาย",
          "valueEN": "Make appointment"
        },
        "id": {
          "type": "value",
          "value": "ModSelectAppointmentDatetimeUX-label-39"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"6px\"}"
        }
      },
      "seq": 39,
      "void": false
    },
    {
      "from": null,
      "id": 40,
      "name": "div",
      "parent": 12,
      "props": {
        "children": {
          "type": "code",
          "value": "props.deviceDropdown"
        },
        "id": {
          "type": "value",
          "value": "ModSelectAppointmentDatetimeUX-div-40"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 22,
      "void": false
    },
    {
      "from": null,
      "id": 41,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "code",
          "value": "props.table"
        },
        "id": {
          "type": "value",
          "value": "ModSelectAppointmentDatetimeUX-div-41"
        }
      },
      "seq": 42,
      "void": false
    },
    {
      "from": null,
      "id": 42,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui divider"
        },
        "id": {
          "type": "value",
          "value": "CardSelectAppointmentDatetimeUX-div-42"
        },
        "style": {
          "type": "code",
          "value": "{display:props.hideHeader?\"none\": \"\"}"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 43,
      "name": "FormField",
      "parent": 7,
      "props": {
        "className": {
          "type": "value",
          "value": "inline-label"
        },
        "id": {
          "type": "value",
          "value": "CardSelectAppointmentDatetimeUX-FormField-43"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{position: \"relative\", paddingRight: 0, display: props.showSelectDivision?\"\":\"none\"}"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 12,
      "void": false
    },
    {
      "from": null,
      "id": 45,
      "name": "div",
      "parent": 43,
      "props": {
        "children": {
          "type": "value",
          "value": "เลือกแผนก",
          "valueEN": "Select division"
        },
        "id": {
          "type": "value",
          "value": "CardSelectAppointmentDatetimeUX-div-45"
        },
        "style": {
          "type": "code",
          "value": "{position: \"absolute\", top: \"-1.25rem\"}"
        }
      },
      "seq": 46,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 46,
      "name": "Dropdown",
      "parent": 43,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardSelectAppointmentDatetimeUX-Dropdown-46"
        },
        "name": {
          "type": "value",
          "value": "division"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeFilter"
        },
        "options": {
          "type": "code",
          "value": "props.divisionOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.filter?.division ?? \"\""
        }
      },
      "seq": 45,
      "void": false
    },
    {
      "from": null,
      "id": 47,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSelectAppointmentDatetimeUX-div-47"
        },
        "style": {
          "type": "code",
          "value": "{ display: props.hideHeader&& props.filter?.devices?.length?\"flex\":\"none\", justifyContent: \"flex-end\", marginTop: \"1rem\"}"
        }
      },
      "seq": 47,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 48,
      "name": "Button",
      "parent": 47,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "color": {
          "type": "value",
          "value": "green"
        },
        "disabled": {
          "type": "code",
          "value": "props.disabledMakeAppointment"
        },
        "id": {
          "type": "value",
          "value": "CardSelectAppointmentDatetimeUX-Button-48"
        },
        "onClick": {
          "type": "code",
          "value": "props.onMakeAppointment"
        },
        "size": {
          "type": "value",
          "value": "small"
        }
      },
      "seq": 48,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 49,
      "name": "Icon",
      "parent": 48,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSelectAppointmentDatetimeUX-Icon-49"
        },
        "name": {
          "type": "value",
          "value": "calendar alternate outline"
        }
      },
      "seq": 49,
      "void": false
    },
    {
      "from": null,
      "id": 50,
      "name": "label",
      "parent": 48,
      "props": {
        "children": {
          "type": "value",
          "value": "ทำการนัดหมาย",
          "valueEN": "Make appointment"
        },
        "id": {
          "type": "value",
          "value": "CardSelectAppointmentDatetimeUX-label-50"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"6px\"}"
        }
      },
      "seq": 50,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "isMounted": false,
  "memo": false,
  "name": "CardSelectAppointmentDatetimeUX",
  "project": "IsHealth",
  "screenPropsDefault": {
    "cannotPay": false,
    "cashAmountText": "14",
    "citizenID": "31020000552",
    "oweText": 123,
    "patientNameAndHN": "HN: xxxxx นายทดสอบ",
    "sumAmount": {
      "price": 100,
      "reimbursable": 42
    }
  },
  "width": 75
}

*********************************************************************************** */
